import { css } from '@emotion/core';
import { rgba, variables, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  global = variables.global,
  font = variables.font;
var colors = tokens.colors;
export var container = position => /*#__PURE__*/css("position:fixed;bottom:0;left:0;right:0;transition:height ease-in 0.3s;height:", position, ";padding-bottom:10px;background-color:", colour.white, ";border-radius:16px 16px 0 0;box-shadow:0 3px 6px 0 ", rgba(colour.black, 0.15), ",0 5px 10px 0 ", rgba(colour.black, 0.5), ";z-index:", global.layerPopout + global.layerModal, ";.domain-checkbox__control-switch{&::before,&::after{content:'';}}");
export var showOverlaysLabel = {
  name: "v7ibj3",
  styles: "display:inline-block;vertical-align:middle;"
};
export var innerContainer = {
  name: "1q7njkh",
  styles: "margin-top:10px;"
};
export var headingContainer = /*#__PURE__*/css("margin:0 18px;padding:7px 0;font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:", font.headingFontWeight, ";color:", colour.neutral600, ";");
export var headingText = {
  name: "18keu6n",
  styles: "vertical-align:middle;display:inline-block;border:0;background:none;outline:0;font:inherit;color:inherit;width:calc(100% - 80px);"
};
export var toggleContainer = isOpen => /*#__PURE__*/css("float:right;vertical-align:middle;display:inline-block;", isOpen && /*#__PURE__*/css("> label > div > div{background-color:", colors.interactive.base.default, " !important;}"));
export var sliderToggle = /*#__PURE__*/css("display:inline-block;background-color:", colour.neutral200, ";border-radius:3px;outline:0;border:0;width:32px;height:6px;");
export var sliderToggleContainer = {
  name: "1pn4k23",
  styles: "text-align:center;margin-top:10px;"
};
export var panelBody = popupContainerHeight => /*#__PURE__*/css("overflow-y:auto;width:100%;height:", popupContainerHeight, ";> div{border:0;margin-bottom:100px;}");
export var tabWrapper = {
  name: "o54haw",
  styles: "display:flex;gap:28px;overflow:auto;margin-left:16px;"
};